import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../store/hooks';
import NtxTable from '../../../components/DataTable/NtxTable';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

interface props {
  setID: React.Dispatch<React.SetStateAction<string>>; // For Update
}

const EquipmentsOdometerList: React.FC<props> = props => {

  const {HasPermission} = usePermissions();
  const { t, i18n } = useTranslation();

  const { OdometerListByFleetEquipmentsId } = useAppSelector(state => state.EquipmentsOdometer);

  const columns = [
    { title: t('Read Source'), key: 'sourceRead' },
    { title: t('Odometer'), key: 'sdate' },
    { title: t('DateOfReading'), key: 'DateOfReading' },
    { title: t('DriverName'), key: 'Name' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = OdometerListByFleetEquipmentsId?.slice()
    ?.sort((a, b) => new Date(b.readDate).getTime() - new Date(a.readDate).getTime()) // ترتيب تنازلي حسب التاريخ
    ?.map(item => {
      let rowClass;

      return {
        Name: i18n.language === 'en' ? item.peopleName : item.peopleName2,
        sdate: item.odometer === null ? '' : String(item.odometer),
        DateOfReading: item.readDate,
        sourceRead: (
          <span
            className={`badge bg-${
              item.sourceRead === 'Workorder'
                ? 'primary'
                : item.sourceRead === 'TakeOver'
                ? 'info'
                : item.sourceRead === 'HandOver'
                ? 'success'
                : item.sourceRead === 'Scan'
                ? 'warning'
                : item.sourceRead === 'Manual'
                ? 'dark'
                : 'secondary'
            }`}
          >
            {item.sourceRead}
          </span>
        ),

        action: (
          <button
           hidden={!HasPermission('FleetEditEquipmentOdometer')}
            disabled={item.sourceRead !== 'Manual'}
            type='button'
            className='btn btn-sm btn-outline-theme'
            data-bs-toggle='modal'
            data-bs-target='#UpdateEquipmentsOdometer'
            onClick={() => props.setID(item.id)}
          >
            <i className='far fa-lg fa-fw fa-edit me-2'></i>
            {t('Button.Edit')}
          </button>
        ),

        rowClass // استخدم rowClass هنا
      };
    });

  return (
    <NtxTable
      data={tableData || []}
      columns={columns}
      dataPerPage={10}
      theadClass=''
      tableClass='table text-nowrap table-hover '
      enableSearch
      showRecordsSelector
    />
  );
};

export default EquipmentsOdometerList;
